import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../../services/authentication/authentication.service';

@Component({
  selector: 'app-customer-login',
  templateUrl: './customer-login.component.html',
  styleUrls: ['./customer-login.component.scss']
})
export class CustomerLoginComponent implements OnInit {
  email = '';
  password = '';

  errorMessage = '';
  isLoading = false;

  constructor(
    private auth: AuthenticationService,
    private route: ActivatedRoute,
    private router: Router
  ) { }

  loadPageData(): void { }

  login(): void {
    this.errorMessage = '';

    if (!this.email || !this.email.trim()) {
      this.errorMessage = 'Please enter your email address.';
      return;
    }

    if (!this.password || !this.password.trim()) {
      this.errorMessage = 'Please enter your password.';
      return;
    }

    this.isLoading = true;

    this.auth.customerLogin(this.email.trim(), this.password).subscribe({
      next: () => {
        this.isLoading = false;

        const returnUrl = this.route.snapshot.queryParamMap.get('returnUrl') || '/customer/dashboard';
        this.router.navigateByUrl(returnUrl);
      },
      error: (error) => {
        this.isLoading = false;

        if (error?.status === 401 || error?.status === 400) {
          this.errorMessage = 'Invalid email address or password. Please try again.';
          return;
        }

        if (error?.error?.message) {
          this.errorMessage = error.error.message;
          return;
        }

        this.errorMessage = 'Login failed. Please check your details and try again.';
      }
    });
  }

  clearError(): void {
    if (this.errorMessage) {
      this.errorMessage = '';
    }
  }

  ngOnInit(): void {
    this.loadPageData();
  }
}